import { Exports_GetDefinitions } from "data/endpoints";
import React from "react";
import ExportDefinitionSimplifiedDTO from "features/exports/dtos/ExportDefinitionSimplifiedDTO";
import CardLink from "features/shared/components/buttons/CardLink";
import { useQuery } from "data/hooks/useQuery";
import NoContentWrapper from "features/shared/components/noContentWrapper/NoContentWrapper";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

type Props = {};

const ExportsSections = (props: Props) => {
  // translations
  const { i18n } = useTranslation();

  // router
  const history = useHistory();

  // side-effects
  // fetch-data
  const { data: exports, loadStatus } = useQuery<
    ExportDefinitionSimplifiedDTO[]
  >(
    {
      url: Exports_GetDefinitions,
    },
    [],
    [i18n.language]
  );

  // sub-renders
  const renderExportDefinitions = () => {
    return exports.map((item) => (
      <div className="col-sm-6 col-lg-4 px-2" key={item.exportDefinitionId}>
        <CardLink
          title={item.name!}
          icon="database"
          onClick={() => history.push(`/exports/${item.exportDefinitionId}`)}
        />
      </div>
    ));
  };

  // render
  return (
    <NoContentWrapper
      data={exports}
      loadStatus={loadStatus}
      noContentAsAlert
    >
      <div className="row no-gutters mx-n2">
        {renderExportDefinitions()}
      </div>
    </NoContentWrapper>
  );
};

export default ExportsSections;
